module.exports = __webpack_public_path__ + "img/atlas-logo.392622ef.png";